const RULES_CONFIG = {
  version: '4.0',
  lastUpdated: '2026-05-12',
  description: 'Ruta Logica v4.0 - Configuracion central de inteligencia legal previsional.',

  thresholds: {
    confiscatoriedad: 0.15,
    desviacionAnomala: 0.30,
    desviacionHaberReferenciaPct: 0.02,
    desviacionRetroReferenciaPct: 0.05,
    descripcion: {
      confiscatoriedad: 'Umbral de alerta por quita sobre remuneracion real.',
      desviacionAnomala: 'Umbral de salto mensual anomalo para revision pericial.',
    },
  },

  indices: {
    estrategiaDefault: 'POR_FECHA_CESE',
    mapeoFallos: {
      pre2017: {
        serie: 'ISBIC',
        doctrina: 'Elliff',
        condicion: 'fechaCese < 2017-01',
      },
      post2017: {
        serie: 'RIPTE',
        doctrina: 'Blanco',
        condicion: 'fechaCese >= 2017-01',
      },
    },
  },

  protocol: {
    divisor: 120,
    divisorPolicy: 'legal_120',
    seleccion: 'cronologico_inverso',
    sumarSimultaneidad: true,
    ventana: {
      nombre: 'Regla de Oro de las 120',
      jurisprudencia: 'Pardi',
      reglas: {
        bacheCerrado: true,
        promediarMesesEnCero: false,
        criterio: 'retroceder_desde_cese_hasta_120_meses_con_aportes_reales',
      },
    },
    topes: {
      detectarConfiscatoriedad: true,
      jurisprudencia: 'Gualtieri',
      alertaQuitaSuperiorA: 0.15,
      consolidarSimultaneidadAntesDelTope: true,
    },
  },

  subsanacion: {
    objetivoAportesAnios: 30,
    ordenAplicacion: ['decreto_475_2021_tareas_cuidado', 'ley_27705_moratoria'],
    decreto_475_2021_tareas_cuidado: {
      activo: true,
      aplicaSiAportesMenoresAnios: 30,
      reglas: {
        porHijo: 1,
        porHijoConDiscapacidad: 2,
      },
      notas: 'Reconocimiento de servicios por tareas de cuidado segun Decreto 475/2021.',
    },
    ley_27705_moratoria: {
      activo: true,
      aplicaSiAportesMenoresAnios: 30,
      formulaMesesFaltantes: 'max(0, ceil((30 - aniosAporteTotal) * 12))',
      notas: 'Regularizacion por Unidad de Pago de Deuda Previsional conforme Ley 27.705.',
    },
  },

  autonomos: {
    doctrinas: {
      volonte_makler: {
        activa: true,
        nombre: 'Doctrina Volonte / Makler',
        regla: 'actualizar_categorias_autonomos_por_indice_general',
        objetivo: 'Evitar computo nominal depreciado o equivalente a cero en historiales autonomos.',
      },
      separacion_haberes_mixtos: {
        activa: true,
        nombre: 'Separacion proporcional de haberes',
        regla: 'calculo_independiente_dependencia_y_autonomo',
        objetivo: 'Evitar contaminacion del promedio de dependencia por tramos autonomos historicos.',
      },
    },
  },

  movilidad: {
    hitos: [
      {
        key: 'badaro_2002_2006',
        desde: '2002-01',
        hasta: '2006-12',
        norma: 'Fallo Badaro',
        regla: 'incremento_fijo',
        valor: 0.886,
      },
      {
        key: 'ley_26417_2009_2017',
        desde: '2009-01',
        hasta: '2017-12',
        norma: 'Ley 26.417',
        regla: 'movilidad_legal_periodica',
      },
      {
        key: 'fernandez_pastor_2018_2019',
        desde: '2018-01',
        hasta: '2019-12',
        norma: 'Fallo Fernandez Pastor',
        regla: 'empalme_movilidad',
      },
      {
        key: 'caliva_2020',
        desde: '2020-01',
        hasta: '2020-12',
        norma: 'Fallo Caliva',
        regla: 'impugnacion_decretos_si_inflacion_superior',
      },
      {
        key: 'ley_27609_2021_actualidad',
        desde: '2021-01',
        hasta: 'actualidad',
        norma: 'Ley 27.609',
        regla: 'movilidad_legal_mas_ipc_segun_calendario',
      },
    ],
  },

  perfiles: {
    especial: {
      regimenes: ['DOCENTE', 'INVESTIGADOR', 'DIPLOMATICO', 'LUZ_Y_FUERZA'],
      accion: 'calculo_ultimo_cargo_82_movil',
    },
    general: {
      regimen: 'LEY_24241',
      accion: 'flujo_general_v4',
    },
  },

  regimenDocente: {
    decreto: '137/05',
    edadMinima: { M: 60, F: 57, X: 57 },
    alicuotaAporteDiferencial: 0.13,
    porcentajeSustitucion: 0.82,
    minimoMesesContinuosCargo: 60,
    minimoMesesAlternadosCargo: 120,
    movilidad: {
      serie: 'MOVILIDAD_RIPDOC',
      frecuencia: 'semestral_marzo_septiembre',
    },
    doctrinaExencionTopes: 'Gemelli, Esther c/ ANSES',
  },

  liquidacionFinal: {
    fechaCorte: null,
    retroactividad: {
      limiteAnios: 2,
      fundamento: 'Art. 82 Ley 18.037',
      requiereFechaPrimerReclamoAdministrativo: true,
      requiereHitosInterrupcion: true,
      hitosInterrupcion: [
        'fechaOtorgamientoBeneficio',
        'fechaReclamoAdministrativo',
        'fechaDenegatoriaODemanda',
      ],
    },
    intereses: {
      tipo: 'PASIVA_14290',
      descripcion: 'Aplicar interes mensual sobre cada diferencia no abonada.',
      jurisdicciones: {
        CABA_FEDERAL: { tasaDefault: 'PASIVA_14290', criterio: 'Camara Federal Seguridad Social', vigenciaDesde: '1991-01' },
        PROVINCIA_ACTIVA: { tasaDefault: 'ACTIVA_JUZGADO', criterio: 'Criterio provincial tasa activa', vigenciaDesde: '1991-01' },
      },
    },
    ganancias: {
      triggerEdadMayorAnios: 80,
      triggerSaludComprometida: true,
      doctrina: 'Fallo Garcia',
      accion: 'marcar_exencion_ganancias_retroactivo',
    },
  },

  scenarioMatrix: {
    GENERAL_DEPENDENCIA: {
      label: 'General Dependencia',
      divisorPolicy: 'legal_120',
      indiceStrategy: 'POR_FECHA_CESE',
      habilitaMoratoria: true,
      habilitaTareasCuidado: true,
    },
    GENERAL_MIXTO: {
      label: 'General Mixto',
      divisorPolicy: 'legal_120',
      indiceStrategy: 'POR_FECHA_CESE',
      habilitaMoratoria: true,
      habilitaTareasCuidado: true,
    },
    ESPECIAL_REGIMEN: {
      label: 'Regimen Especial',
      divisorPolicy: 'legal_120',
      indiceStrategy: 'POR_FECHA_CESE',
      habilitaMoratoria: false,
      habilitaTareasCuidado: false,
    },
    DOCENTE_PURO: {
      label: 'Docente Puro',
      divisorPolicy: 'especial_docente',
      indiceStrategy: 'RIPDOC',
      habilitaMoratoria: false,
      habilitaTareasCuidado: false,
    },
    DOCENTE_MIXTO: {
      label: 'Docente Mixto',
      divisorPolicy: 'prorrateado_docente_mixto',
      indiceStrategy: 'RIPDOC',
      habilitaMoratoria: false,
      habilitaTareasCuidado: false,
    },
    PENSION_DERIVADA: {
      label: 'Pension Derivada',
      divisorPolicy: 'pension_derivada',
      indiceStrategy: 'NO_RECALCULA_BASE',
      habilitaMoratoria: false,
      habilitaTareasCuidado: false,
    },
    PENSION_DIRECTA: {
      label: 'Pension Directa',
      divisorPolicy: 'pension_directa_60',
      indiceStrategy: 'POR_FECHA_FALLECIMIENTO',
      edades: { m: 65, f: 60 },
      tasaSustitucionRegular: 1.0,
      tasaSustitucionIrregular: 0.7,
      habilitaMoratoria: false,
      habilitaTareasCuidado: false,
    },
  },

  normativeThresholdsByVersion: {
    '4.0': {
      confiscatoriedadPct: 0.15,
      fundamento: 'Fallo Gualtieri y doctrina CSJN sobre quitas irrazonables',
      topeLey: 'Art. 9 Ley 24.463',
    },
  },

  diagnostico: {
    condicionConfiscatorio: '(haberReajustado - haberAnses) / haberAnses > 0.15',
    mensaje: 'DIAGNOSTICO: CONFISCATORIO - PROCEDE DEMANDA',
  },
}

export default RULES_CONFIG
